module.exports = __webpack_public_path__ + "img/jumbotron-slogan.8dc9761b.jpg";